import { useTheme } from '@mui/material';
import { Appearance, StripeElementsOptions } from '@stripe/stripe-js';

function useStripeOptions({
  clientSecret,
}: {
  clientSecret?: string;
} = {}) {
  const theme = useTheme();

  const fonts = [
    { cssSrc: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400' },
  ];

  const appearance: Appearance = {
    labels: 'floating',
    variables: {
      colorPrimary: theme.palette.primary.main,
      colorDanger: theme.palette.primary.main,
      colorBackground: '#ffffff',
      colorText: theme.palette.darkGrey.main,
      fontFamily: 'Montserrat',
      borderRadius: '5px',
      spacingUnit: '4px',
      fontSizeBase: '16px',
      fontWeightBold: '700',
      fontWeightLight: '400',
      colorTextPlaceholder: theme.palette.outlineGrey.main,
    },
    rules: {
      '.Label': {
        color: theme.palette.outlineGrey.main,
      },
      '.Input': {
        borderColor: theme.palette.outlineGrey.main,
      },
    },
  };

  const options: StripeElementsOptions = {
    appearance,
    fonts,
    clientSecret,
  };

  return options;
}

export default useStripeOptions;
